import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";

import { ContentPage } from "@pages/content";
import { LifecyclePage } from "@pages/lifecycle";
import { MembersPage } from "@pages/members";
import { OverviewPage } from "@pages/overview";
import { AlertsPage } from "@pages/settings";
import { cn } from "@shared/lib";

export function AppRouter() {
  return (
    <div className="flex min-h-screen flex-col">
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<OverviewPage />} />
          <Route path="/overview" element={<OverviewPage />} />
          <Route path="/members" element={<MembersPage />} />
          <Route path="/content" element={<ContentPage />} />
          <Route path="/lifecycle" element={<LifecyclePage />} />
          <Route path="/alerts" element={<AlertsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      <BottomNav />
    </div>
  );
}

function BottomNav() {
  const { pathname } = useLocation();
  const items = [
    { to: "/overview", label: "Overview", match: ["/", "/overview"] },
    { to: "/members", label: "Members", match: ["/members"] },
    { to: "/lifecycle", label: "Lifecycle", match: ["/lifecycle"] },
    { to: "/content", label: "Content", match: ["/content"] },
    { to: "/alerts", label: "Alerts", match: ["/alerts"] },
  ] as const;
  return (
    <nav
      aria-label="Primary"
      className="sticky bottom-0 z-10 flex justify-around border-t bg-background/95 py-2 backdrop-blur"
    >
      {items.map((item) => {
        const isActive = item.match.some((m) => m === pathname);
        return (
          <Link
            key={item.to}
            to={item.to}
            aria-current={isActive ? "page" : undefined}
            className={cn(
              "flex h-11 min-w-[88px] items-center justify-center rounded-md px-3 text-sm font-medium",
              isActive
                ? "bg-muted text-foreground"
                : "text-muted-foreground hover:bg-muted",
            )}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
}
